import Polygon from "./polygon.js";

class Rectangle extends Polygon {
  constructor(...args) {
    let x, y, width, height, radius;
    if (args.length >= 4 && args.every((arg) => typeof arg === "number")) {
      x = args[0];
      y = args[1];
      width = args[2];
      height = args[3];
      radius = args[4] || 0;
    } else if (
      args.length >= 2 &&
      Array.isArray(args[0]) &&
      Array.isArray(args[1])
    ) {
      x = Math.min(args[0][0], args[1][0]);
      y = Math.min(args[0][1], args[1][1]);
      width = Math.abs(args[0][0] - args[1][0]);
      height = Math.abs(args[0][1] - args[1][1]);
      radius = args[2] || 0;
    } else if (
      args.length >= 2 &&
      typeof args[0] === "object" &&
      typeof args[1] === "object"
    ) {
      x = Math.min(args[0].x, args[1].x);
      y = Math.min(args[0].y, args[1].y);
      width = Math.abs(args[0].x - args[1].x);
      height = Math.abs(args[0].y - args[1].y);
      radius = args[2] || 0;
    } else {
      throw new Error("Invalid arguments for Rectangle constructor");
    }

    let pts;

    if (radius !== 0) {
      const bulge = 0.414213562373095;
      pts = [
        { x: x + radius, y, bulge },
        { x: x + width - radius, y },
        { x: x + width, y: y + radius, bulge },
        { x: x + width, y: y + height - radius },
        { x: x + width - radius, y: y + height, bulge },
        { x: x + radius, y: y + height },
        { x, y: y + height - radius, bulge },
        { x, y: y + radius },
      ];
    } else {
      pts = [
        { x, y },
        { x: x + width, y },
        { x: x + width, y: y + height },
        { x: x, y: y + height },
      ];
    }

    super(pts);
    this.type = "rectangle";
  }
}

export default Rectangle;
